import { Route, Routes } from 'react-router-dom';

import { LEGAL_PAGES } from '@/constants/routes';
import { NotFoundHandler } from '@/contexts/generic-page-context';

import { LegalDataPrivacy } from './LegalDataPrivacy';
import { LegalImpressum } from './LegalImpressum';
import { LegalTermsAndConditions } from './LegalTermsAndConditions';

export const LegalRoutes = () => (
  <Routes>
    <Route path={LEGAL_PAGES.impressum} element={<LegalImpressum />} />
    <Route path={LEGAL_PAGES.dataPrivacy} element={<LegalDataPrivacy />} />
    <Route
      path={LEGAL_PAGES.termsAndConditions}
      element={<LegalTermsAndConditions />}
    />
    <Route path="*" element={<NotFoundHandler />} />
  </Routes>
);
